// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"filterDropdown_inputContainer__2yKQC","placeholder":"filterDropdown_placeholder__1nkjy","wrapText":"filterDropdown_wrapText__FVEgn"};